import { MobiDocument } from './MobiDocument';

export class ChampLibreDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private date_created: string;
    private date_updated: string;
    private champlibrecomponenttypeenum: string;
    private intitule: string;
    private ordre: string;
    private champlibreinoedomaineenum: string;

    public constructor(champLibre: any) {
        super();
        this._id = champLibre._id;
        this._rev = champLibre._rev;
        this.id = champLibre.id;
        this.date_created = champLibre.date_created;
        this.date_updated = champLibre.date_updated;
        this.champlibrecomponenttypeenum = champLibre.champlibrecomponenttypeenum;
        this.intitule = champLibre.intitule;
        this.ordre = champLibre.ordre;
        this.champlibreinoedomaineenum = champLibre.champlibreinoedomaineenum;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }


    public getDate_created(): string {
        return this.date_created;
    }

    public setDate_created(date_created: string): void {
        this.date_created = date_created;
    }

    public getDate_updated(): string {
        return this.date_updated;
    }

    public setDate_updated(date_updated: string): void {
        this.date_updated = date_updated;
    }

    public getChamplibrecomponenttypeenum(): string {
        return this.champlibrecomponenttypeenum;
    }

    public setChamplibrecomponenttypeenum(champlibrecomponenttypeenum: string): void {
        this.champlibrecomponenttypeenum = champlibrecomponenttypeenum;
    }

    public getIntitule(): string {
        return this.intitule;
    }

    public setIntitule(intitule: string): void {
        this.intitule = intitule;
    }

    public getOrdre(): string {
        return this.ordre;
    }

    public setOrdre(ordre: string): void {
        this.ordre = ordre;
    }

    public getChamplibreinoedomaineenum(): string {
        return this.champlibreinoedomaineenum;
    }

    public setChamplibreinoedomaineenum(champlibreinoedomaineenum: string): void {
        this.champlibreinoedomaineenum = champlibreinoedomaineenum;
    }

}